<!-- Toast Messages for embedded/web component mode only -->
@if (embeddedMode) {
  <p-toast
    position="top-right"
    [breakpoints]="{ '920px': { width: '100%', right: '0', left: '0' } }"
  />
}

<div class="create-scheduled-order-page">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <!-- Left Sidebar Skeleton -->
    <div class="skeleton-left-sidebar">
      <!-- Collapse toggle skeleton -->
      <div class="skeleton-sidebar-header">
        <p-skeleton width="2rem" height="2rem" borderRadius="0.5rem" />
      </div>

      <!-- Step skeletons -->
      <div class="skeleton-steps">
        <div class="skeleton-step" *ngFor="let step of [1, 2, 3, 4, 5, 6]">
          <div class="skeleton-step-content">
            <p-skeleton shape="circle" size="2rem" />
            <div class="skeleton-step-text">
              <p-skeleton width="6rem" height="1rem" />
            </div>
          </div>
        </div>
      </div>

      <!-- Action buttons skeleton -->
      <div class="skeleton-actions">
        <p-skeleton width="100%" height="2.5rem" borderRadius="0.5rem" />
        <p-skeleton width="100%" height="2.5rem" borderRadius="0.5rem" />
      </div>
    </div>

    <!-- Center Content Skeleton -->
    <div class="skeleton-center-content">
      <!-- Section banner skeleton -->
      <div class="skeleton-banner">
        <p-skeleton width="60%" height="1.5rem" styleClass="mb-2" />
        <p-skeleton width="80%" height="1rem" />
      </div>

      <!-- Content wrapper skeleton -->
      <div class="skeleton-content-wrapper">
        <!-- Form fields -->
        <div class="skeleton-form-section">
          <p-skeleton width="8rem" height="1rem" styleClass="mb-2" />
          <p-skeleton width="100%" height="2.5rem" borderRadius="0.5rem" />
        </div>

        <div class="skeleton-form-section">
          <p-skeleton width="10rem" height="1rem" styleClass="mb-2" />
          <p-skeleton width="100%" height="2.5rem" borderRadius="0.5rem" />
        </div>

        <div class="skeleton-form-section">
          <p-skeleton width="9rem" height="1rem" styleClass="mb-2" />
          <p-skeleton width="100%" height="4rem" borderRadius="0.5rem" />
        </div>
      </div>
    </div>

    <!-- Right Sidebar Skeleton (hidden on mobile) -->
    <div class="skeleton-right-sidebar">
      <p-skeleton width="60%" height="1.25rem" styleClass="mb-3" />
      <!-- Totals skeleton -->
      <div class="skeleton-totals">
        <div class="skeleton-total-row" *ngFor="let row of [1, 2, 3, 4, 5]">
          <p-skeleton width="6rem" height="1rem" />
          <p-skeleton width="4rem" height="1rem" />
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div *ngIf="!isLoading && formGroup" class="page-content">
    <!-- Top Header with Create Button (Mobile Only) -->
    <div class="page-header">
      <div class="header-left">
        <p-button
          icon="pi pi-arrow-left"
          [rounded]="true"
          [text]="true"
          (onClick)="cancel()"
          pTooltip="Cancel"
          tooltipPosition="bottom"
        />
      </div>
      <div class="header-right">
        <!-- Mobile Create Button (only visible ≤768px) -->
        <p-button
          icon="pi pi-save"
          [rounded]="true"
          [text]="true"
          [disabled]="isSaving"
          [loading]="isSaving"
          (onClick)="create()"
          pTooltip="Create order"
          tooltipPosition="bottom"
          styleClass="mobile-create-button"
        />

        <!-- Mobile Totals Popover Button (only visible ≤768px) -->
        <p-button
          icon="pi pi-dollar"
          [rounded]="true"
          [text]="true"
          (onClick)="totalsPopover.toggle($event)"
          pTooltip="View totals"
          tooltipPosition="bottom"
          styleClass="mobile-totals-button"
        />
        <p-popover #totalsPopover styleClass="totals-popover">
          <ng-template pTemplate="content">
            <div class="popover-totals-container">
              <h4 class="popover-totals-title">Order Total Summary</h4>
              <app-totals-display
                *ngIf="formComponent"
                [totals]="formComponent.totals"
                [isLoading]="formComponent.isCalculatingTotals"
                [showTitle]="false"
                [hasDisabledItems]="formComponent.hasDisabledItems()"
              />
            </div>
          </ng-template>
        </p-popover>
      </div>
    </div>

    <!-- Form with Sidebar (handles its own actions) -->
    <div class="form-container">
      <app-scheduled-order-form
        [formGroup]="formGroup"
        [siteId]="siteId"
        [site]="site"
        [mode]="'create'"
        [disabled]="isSaving"
        [advancedOptionsAllowed]="advancedOptionsAllowed"
        [tierName]="currentTierName"
        [upgradeUrl]="upgradeUrl"
        [isSaving]="isSaving"
        [showActions]="true"
        [accessToken]="getAccessToken()"
        (formCancel)="cancel()"
        (formSubmit)="create()"
      />
    </div>
  </div>
</div>
